import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FieldSchemeSelfConversionEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const fieldSchemeSelfConversionEntryPoint: EntryPoint<
	FieldSchemeSelfConversionEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<FieldSchemeSelfConversionEntryPointComponent>(
		/* webpackChunkName: "async-admin-pages-field-scheme-self-conversion" */ './FieldSchemeSelfConversionManager.tsx',
	),
	getPreloadProps: () => ({}),
});
